import React, { useEffect } from 'react'
import { EarnConfigType } from 'src/lib/types/rewards'
import InputTextField from 'src/components/common/form-elements/InputTextField'
import { useLocale } from 'src/lib/hooks/useLocal'

interface EarnRuleDialogProps {
  initialEarnConfig: EarnConfigType
  earnConfig: EarnConfigType
  setEarnConfig: (values: EarnConfigType) => void
}

const EarnRuleDialog: React.FC<EarnRuleDialogProps> = ({ earnConfig, setEarnConfig, initialEarnConfig }) => {
  const { t } = useLocale()

  useEffect(() => {
    return setEarnConfig(initialEarnConfig)
  }, [])

  const handleEarnBurnConfigChange = (event: React.ChangeEvent<HTMLInputElement>, inputType: keyof EarnConfigType) => {
    const enteredValue = event.target.value.trim()
    if (!enteredValue) {
      setEarnConfig({ ...earnConfig, [inputType]: null })
      return
    }

    const parsedValue = parseInt(enteredValue, 10)
    if (isNaN(parsedValue)) {
      return
    }

    const maxValue = inputType === 'earnRatio' ? 100 : 1000
    const validatedValue = Math.max(0, Math.min(parsedValue, maxValue))

    setEarnConfig({ ...earnConfig, [inputType]: validatedValue })
  }
  return (
    <>
      <div className='flex flex-col items-start gap-4'>
        <div className='flex flex-col items-start justify-between w-full'>
          <p className='text-sm font-medium text-coal-light'>Percentage of order total to reward</p>
          <InputTextField
            inputValue={earnConfig.earnRatio}
            textFieldId='earn-ratio'
            endIcon={<>%</>}
            handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleEarnBurnConfigChange(event, 'earnRatio')
            }
            inputType='number'
            isFullWidth={true}
            customClass={'!w-1/2'}
          />
        </div>
        <div className='flex flex-row items-center justify-between w-full gap-2'>
          <div className='flex flex-col items-start justify-between w-full'>
            <p className='text-sm font-medium text-coal-light'>Set delay (Optional)</p>
            <InputTextField
              inputValue={earnConfig.delay}
              textFieldId='earn-delay'
              {...(Boolean(earnConfig?.delay) ? { endIcon: <>{t('day', { count: earnConfig?.delay ?? 0 })}</> } : {})}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleEarnBurnConfigChange(event, 'delay')}
              inputPlaceholder={'No delay'}
              inputType='number'
              isFullWidth={true}
            />
          </div>
          <div className='flex flex-col items-start justify-between w-full'>
            <p className='text-sm font-medium text-coal-light'>Set expiry (Optional)</p>
            <InputTextField
              inputValue={earnConfig.expiry}
              textFieldId='earn-expiry'
              {...(Boolean(earnConfig.expiry) ? { endIcon: <>{t('day', { count: earnConfig.expiry ?? 0 })}</> } : {})}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleEarnBurnConfigChange(event, 'expiry')}
              inputPlaceholder={'No expiry'}
              inputType='number'
              isFullWidth={true}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default React.memo(EarnRuleDialog)
